import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { Header } from 'semantic-ui-react';
import { browserRedirect } from '../helpers/utils';

const LoginRedirectPage = () => {
    const { signedIn = false } = useSelector((state) => state.auth);

    return signedIn === true ? (
        <Redirect to="/" />
    ) : (
        <>
            <Header textAlign="center" style={{ marginTop: '30px' }}>
                Please wait while we redirect to login page.
            </Header>
            {browserRedirect('/login')}
        </>
    );
};

export default LoginRedirectPage;
